import * as ko from "knockout";
import * as mapping from "knockout.mapping";
import * as $ from "jquery";
import { Address } from "../../Models/NewspaperRequestModels/address";
import { Newspaper } from "../../Models/NewspaperRequestModels/newspaper";
import { NewNewspaperRequestModel } from "../../Models/NewspaperRequestModels/newNewspaperRequestModel";
import { SubscriptionDetail } from "../../Models/NewspaperRequestModels/subscriptionDetail";
import { isNullOrUndefined } from "util";

class NewspaperRequestFormViewModel {
    newNewspaperRequest: any;;

    subscriptionId: any;

    dropdownsOptions: any;
    isValidForm: any;
    isSaving: any;

    isNewRequest: any;
    isFullAddressChange: any;

    selectedAddressId: any;
    selectedRecipientName: any;
    buttonAction: any;
    
  

    constructor(params: any) {
        let __this = this;

        this.newNewspaperRequest = new NewNewspaperRequestModel();
        this.dropdownsOptions = params.dropdownsOptions;
        
        this.subscriptionId = ko.observable<number>(params.subscriptionId);
        this.buttonAction = ko.observable<number>(params.buttonAction);
        this.isValidForm = this.newNewspaperRequest.IsValidItem;

        this.isSaving = ko.observable<boolean>(false);

        // Session params kiolvasás
        this.selectedAddressId = ko.observable<number>();
        this.selectedRecipientName = ko.observable<string>();

        if (params.sessionOptions.SelectedAddressId() > 0) {
            this.selectedAddressId(params.sessionOptions.SelectedAddressId());
        }

        if (!isNullOrUndefined(params.sessionOptions.SelectedRecipientName())) {
            this.selectedRecipientName(params.sessionOptions.SelectedRecipientName());
        }
        ////////////////////////////
   
        this.isNewRequest = ko.observable<boolean>(params.sessionOptions.SelectedIsNewRequest());
        this.isFullAddressChange = ko.observable<boolean>(params.sessionOptions.SelectedIsFullAddressChange());
 

        this.newNewspaperRequest.SubscriptionId(this.subscriptionId());
        this.newNewspaperRequest.IsNewRequest(this.isNewRequest());
        this.newNewspaperRequest.IsFullAddressChange(this.isFullAddressChange());

        this.isNewRequest.ForEditing = ko.computed({
            read: function () {
                return this.isNewRequest().toString();
            },
            write: function (newValue) {
                this.isNewRequest(newValue === "true");
                this.newNewspaperRequest.IsNewRequest(newValue === "true");
                this.newNewspaperRequest.OriginalQuantity('');
                this.newNewspaperRequest.ModifiedQuantity('');
                this.newNewspaperRequest.ActualQuantity('');
            },
            owner: this
        }); 

        this.isFullAddressChange.ForEditing = ko.computed({
            read: function () {
                return this.isFullAddressChange().toString();
            },
            write: function (newValue) {
                this.isFullAddressChange(newValue === "true");
                this.newNewspaperRequest.IsFullAddressChange(newValue === "true");
                this.newNewspaperRequest.OriginalQuantity('');
                this.newNewspaperRequest.ModifiedQuantity('');
                this.newNewspaperRequest.ActualQuantity('');
            },
            owner: this
        }); 


        // Subscriptions
        this.newNewspaperRequest.ModifiedQuantity.subscribe(function () {
            __this.onChangeModifyQuantity();
        });

        this.newNewspaperRequest.RecipientName.subscribe(function () {
            __this.checkCanGetSubscriptionDetail();
        });

        this.newNewspaperRequest.OldRecipientName.subscribe(function () {
            __this.checkCanGetSubscriptionDetail();
        });

        //console.log(JSON.parse(JSON.stringify(ko.toJS(params))));
        //console.log(JSON.parse(JSON.stringify(ko.toJS(this.dropdownsOptions))));

        this.getFramePrice();

    }

    // Others

    onOldRecipientKeyUp() {
        this.newNewspaperRequest.NewspaperId('');
        $('#newspaper-oldrequest').trigger("chosen:updated");
    }

    onRecipientKeyUp() {
        this.newNewspaperRequest.NewspaperId('');
        $('#newspaper-newrequest').trigger("chosen:updated");
    }

    onAddressSelect() {
        if ( this.selectedAddressId() > 0
             && ( isNullOrUndefined(this.newNewspaperRequest.AddressId())
                  || this.newNewspaperRequest.AddressId() == 0) ) {
            this.newNewspaperRequest.AddressId(this.selectedAddressId());

            if (!isNullOrUndefined(this.selectedRecipientName())
                && this.selectedRecipientName() != "") {
                this.newNewspaperRequest.RecipientName(this.selectedRecipientName());
            }
            else {
                this.newNewspaperRequest.RecipientName("");
            }
        }
        else {
            this.newNewspaperRequest.RecipientName("");
        }

        $('#address').trigger("chosen:updated");

        this.setRequestSession();
    }

    onNewAddressSelect() {
        this.newNewspaperRequest.NewRecipientName("");
    }

    onOldAddressSelect() {
        this.newNewspaperRequest.OldRecipientName("");
    }

    onNewspaperSelect() {
        this.checkCanGetSubscriptionDetail();
    }

    onOrderTypeSelect() {
        this.newNewspaperRequest.ModifiedQuantity('');
        this.onChangeModifyQuantity();
    }

    checkCanGetSubscriptionDetail() {
        if (this.newNewspaperRequest.IsNewRequest()) {
            if (
                this.newNewspaperRequest.AddressId.isValid()
                && this.newNewspaperRequest.RecipientName.isValid()
                && this.newNewspaperRequest.NewspaperId.isValid()
            ) {
                this.getSubscriptionDetail();
            }
        }
        else if ( !this.newNewspaperRequest.IsNewRequest()
                  && !this.newNewspaperRequest.IsFullAddressChange()) {
                if (
                    this.newNewspaperRequest.OldAddressId.isValid()
                    && this.newNewspaperRequest.OldRecipientName.isValid()
                    && this.newNewspaperRequest.NewspaperId.isValid() ) {
                    this.getSubscriptionDetail();
                }
        }
    }

    getSubscriptionDetail(): void {
        // Ellenőrizzük a model struktúrát mielőtt elküldjük
        this.checkNewRequestModel();

        let mappingOption = {
            'ignore': ["IsValidItem"]
        }

        let dataToServer = JSON.stringify(mapping.toJS(this.newNewspaperRequest, mappingOption));

        $.ajax({
            method: "POST",
            url: "NewspaperRequest/GetSubscriptionDetail",
            data: { "paperToSave": dataToServer }
        })
            .done((response) => {
                if (typeof response['data'] !== 'undefined'
                    && response['data'] != null && response['data'] != undefined) {

                    let mappingOption = {
                        'SubscriptionDetail': {
                            create: (args: any) => {
                                return new SubscriptionDetail(args.data);
                            }
                        }
                    }

                    let subDetail = mapping.fromJS(response['data'], mappingOption);

                    this.newNewspaperRequest.Id(subDetail.id());
                    this.newNewspaperRequest.OriginalQuantity(subDetail.resultQuantity());

                    this.onChangeModifyQuantity();
                }
                else {
                    this.newNewspaperRequest.OriginalQuantity(0);
                    this.onChangeModifyQuantity();
                }
            })
            .fail((e) => {

            })
            .always(() => {
                
            });
    }

    onChangeModifyQuantity(): void {
        
        let origi = 0;
        let modified = 0;
        let actual = 0;

        if (!isNaN(parseInt(this.newNewspaperRequest.OriginalQuantity()))
            && typeof parseInt(this.newNewspaperRequest.OriginalQuantity()) == 'number') {
            origi = parseInt(this.newNewspaperRequest.OriginalQuantity());

        }
        
        if (!isNaN(parseInt(this.newNewspaperRequest.ModifiedQuantity()))
            && typeof parseInt(this.newNewspaperRequest.ModifiedQuantity()) == 'number') {
            modified = parseInt(this.newNewspaperRequest.ModifiedQuantity());
        }

        // Ha részleges címmódosítás
        if (!this.isNewRequest() && !this.isFullAddressChange()) {
            if (modified > origi) {
                var cuttedModified = modified.toString().substring(0, modified.toString().length - 1);

                modified = parseInt(cuttedModified);
                this.newNewspaperRequest.ModifiedQuantity(cuttedModified);
            }

            if ((origi - modified) >= 0) {

                actual = (origi - modified);
            }
        }
        else { // Ha új igény rögzítés

            // Lemondás
            if (this.newNewspaperRequest.OrderTypeId() == 4) {
                if (modified > origi) {
                    var cuttedModified = modified.toString().substring(0, modified.toString().length - 1);

                    modified = parseInt(cuttedModified);
                    this.newNewspaperRequest.ModifiedQuantity(cuttedModified);
                }

                if ((origi - modified) >= 0) {

                    actual = (origi - modified);
                }
            }
            else { // Új igény 
                if (modified.toString().length > 5) {
                    var cuttedModified = modified.toString().substring(0, modified.toString().length - 1);
                    modified = parseInt(cuttedModified);
                    this.newNewspaperRequest.ModifiedQuantity(cuttedModified);
                }

                if ((origi + modified) >= 0) {

                    actual = (origi + modified);
                }
            }
        }

        this.newNewspaperRequest.ActualQuantity(actual);
    }

    saveNewspaperRequestItem(parents: any): void {

        if (this.isValidForm()) {
            this.isSaving(true);

            //console.log(JSON.parse(JSON.stringify(ko.toJS(this.newNewspaperRequest))));

            // Ha új akkor address id, különben régi és új address id, mert teljes vagy részleges címmódosításról van szó
            if (this.newNewspaperRequest.IsNewRequest()) {
                let selectedAddress = ko.utils.arrayFirst(this.dropdownsOptions.AddressDropdownOptions(), (address: Address) => {
                    return address.Id() === this.newNewspaperRequest.AddressId();
                });

                this.newNewspaperRequest.AddressName(selectedAddress.Address());
            }
            else {
                let selectedNewAddress = ko.utils.arrayFirst(this.dropdownsOptions.AddressDropdownOptions(), (address: Address) => {
                    return address.Id() === this.newNewspaperRequest.NewAddressId();
                });

                this.newNewspaperRequest.NewAddressName(selectedNewAddress.Address());

                let selectedOldAddress = ko.utils.arrayFirst(this.dropdownsOptions.AddressDropdownOptions(), (address: Address) => {
                    return address.Id() === this.newNewspaperRequest.OldAddressId();
                });

                this.newNewspaperRequest.OldAddressName(selectedOldAddress.Address());
            }

            // Ha új vagy részleges címmódosítás
            if (this.newNewspaperRequest.IsNewRequest()
                || (!this.newNewspaperRequest.IsNewRequest()
                    && !this.newNewspaperRequest.IsFullAddressChange())) {
                let selectedPaper = ko.utils.arrayFirst(this.dropdownsOptions.NewspaperDropdownOptions(), (newspaper: Newspaper) => {
                    return newspaper.Id() === this.newNewspaperRequest.NewspaperId();
                });

                this.newNewspaperRequest.NewspaperName(selectedPaper.Name());
            }

            //let mappingOption = {
            //    'ignore': ["IsValidItem"]
            //}

            // Ellenőrizzük a model struktúrát mielőtt elküldjük
            this.checkNewRequestModel();

            //let dataToServer = JSON.stringify(mapping.toJS(this.newNewspaperRequest, mappingOption));
            let dataToServer = JSON.stringify(ko.toJS(this.newNewspaperRequest));

            /// Loading Add
            $('body').addClass("body-page-scroll-hide");
            $('#pageContainer').addClass("page-overlay");
            $('#pageLoader').addClass("loader");
            $('#pageLoaderText').removeClass("loader-text-hide");

            $.ajax({
                    method: "POST",
                    url: "NewspaperRequest/AddNewNewspaper",
                    data: { "paperToSave": dataToServer }
                })
                    .done((response) => {
                        parents[0].errorVisible(false);
                        parents[0].notificationVisible(false);
                        if (typeof response['error'] !== 'undefined'
                            && response['error'] != null
                            && response['error'] != undefined) {

                            parents[0].errorVisible(true);
                            parents[0].errorMessage(response['error']);
                        }

                        if (typeof response['success'] !== 'undefined'
                            && response['success'] != null
                            && response['success'] != undefined) {

                            parents[0].errorVisible(false);
                            parents[0].notificationVisible(true);
                            parents[0].notificationMessage(response['success']);

                            setTimeout(function () {

                                /// Loading Add
                                $('body').addClass("body-page-scroll-hide");
                                $('#pageContainer').addClass("page-overlay");
                                $('#pageLoader').addClass("loader");
                                $('#pageLoaderText').removeClass("loader-text-hide");

                                location.reload();
                            }, 1200);
                        }
                    })
                    .fail((e) => {

                        parents[0].notificationVisible(false);
                        parents[0].errorVisible(true);
                        parents[0].errorMessage("A tételt nem sikerült hozzáadni. Kérjük próbálja meg újra.");
                    })
                    .always(() => {
                        /// Loading Remove
                        $('body').removeClass("body-page-scroll-hide");
                        $('#pageContainer').removeClass("page-overlay");
                        $('#pageLoader').removeClass("loader");
                        $('#pageLoaderText').addClass("loader-text-hide");

                        this.isSaving(false);
                    });
        }

    }

    getFramePrice(): void {
        $.ajax({
            method: "POST",
            url: "NewspaperRequest/GetFramePrice",
            data: {}
        })
            .done((response) => {
                if (typeof response['data'] !== 'undefined'
                    && response['data'] != null
                    && response['data'] != undefined) {

                    this.newNewspaperRequest.FramePrice(response['data']);
                }
            })

            .fail((e) => {

            });
    }

    checkNewRequestModel(): void {

        if (typeof ko.toJS(this.newNewspaperRequest.SubscriptionId()) === 'undefined') {
            this.newNewspaperRequest.SubscriptionId(0);
        }

        if (typeof ko.toJS(this.newNewspaperRequest.Id()) === 'undefined') {
            this.newNewspaperRequest.Id(0);
        }

        if (typeof ko.toJS(this.newNewspaperRequest.AddressId()) === 'undefined') {
            this.newNewspaperRequest.AddressId(0);
        }

        if (typeof ko.toJS(this.newNewspaperRequest.NewAddressId()) === 'undefined') {
            this.newNewspaperRequest.NewAddressId(0);
        }

        if (typeof ko.toJS(this.newNewspaperRequest.OldAddressId()) === 'undefined') {
            this.newNewspaperRequest.OldAddressId(0);
        }

        if (typeof ko.toJS(this.newNewspaperRequest.AddressName()) === 'undefined') {
            this.newNewspaperRequest.AddressName('');
        }

        if (typeof ko.toJS(this.newNewspaperRequest.NewAddressName()) === 'undefined') {
            this.newNewspaperRequest.NewAddressName('');
        }

        if (typeof ko.toJS(this.newNewspaperRequest.OldAddressName()) === 'undefined') {
            this.newNewspaperRequest.OldAddressName('');
        }

        if (typeof ko.toJS(this.newNewspaperRequest.RecipientName()) === 'undefined') {
            this.newNewspaperRequest.RecipientName('');
        }

        if (typeof ko.toJS(this.newNewspaperRequest.NewRecipientName()) === 'undefined') {
            this.newNewspaperRequest.NewRecipientName('');
        }

        if (typeof ko.toJS(this.newNewspaperRequest.OldRecipientName()) === 'undefined') {
            this.newNewspaperRequest.OldRecipientName('');
        }

        if (typeof ko.toJS(this.newNewspaperRequest.NewspaperId()) === 'undefined') {
            this.newNewspaperRequest.NewspaperId(0);
        }

        if (typeof ko.toJS(this.newNewspaperRequest.NewspaperName()) === 'undefined') {
            this.newNewspaperRequest.NewspaperName('');
        }

        if (typeof ko.toJS(this.newNewspaperRequest.OrderTypeId()) === 'undefined') {
            this.newNewspaperRequest.OrderTypeId(0);
        }
        
        if (typeof ko.toJS(this.newNewspaperRequest.OriginalQuantity()) === 'undefined'
            || isNaN(parseInt(this.newNewspaperRequest.OriginalQuantity()))) {
            
            this.newNewspaperRequest.OriginalQuantity(0);
        }

        if (typeof ko.toJS(this.newNewspaperRequest.ModifiedQuantity()) === 'undefined'
            || isNaN(parseInt(this.newNewspaperRequest.ModifiedQuantity()))) {
            this.newNewspaperRequest.ModifiedQuantity(0);
        }

        if (typeof ko.toJS(this.newNewspaperRequest.ActualQuantity()) === 'undefined'
            || isNaN(parseInt(this.newNewspaperRequest.ActualQuantity()))) {
            this.newNewspaperRequest.ActualQuantity(0);
        }

        if (typeof ko.toJS(this.newNewspaperRequest.FramePrice()) === 'undefined') {
            this.newNewspaperRequest.FramePrice(0);
        }
    }

    setRequestSession(): void {
        var __this = this;

        $.ajax({
            method: "POST",
            url: "NewspaperRequest/SetNewpaperRequestSession",
            data: {
                "isNewRequest": JSON.stringify(__this.isNewRequest()),
                "isFullAddressChange": JSON.stringify(__this.isFullAddressChange()),
                "AddressId": JSON.stringify(__this.newNewspaperRequest.AddressId()),
                "RecipientName": __this.newNewspaperRequest.RecipientName()
            }
        })
            .done((response) => {})
            .fail((e) => {});
    }
}

export class NewspaperRequestFormComponent {
    constructor() {
        return {
            viewModel: NewspaperRequestFormViewModel,
            template: require("text-loader!./newspaperRequestFormView.html")
        }
    }
}